import React from 'react';
import { createRoot } from 'react-dom/client';

// Wraps a React component as a plain Vue component-options object so it can be
// used directly as a vue-router route `component`. Keeps one React root alive
// for the lifetime of the Vue host instance (vue-router already fully
// unmounts/remounts routed views on navigation, so no extra persistence logic
// is needed here).
export function wrapReactView(ReactComponent, mapStoreToProps) {
  return {
    render(h) {
      return h('div', {
        ref: 'mount',
        staticClass: 'react-view-host',
        style: { height: '100%', width: '100%' },
      });
    },

    computed: {
      bridgeProps() {
        return mapStoreToProps ? mapStoreToProps(this.$store, this) : {};
      },
    },

    watch: {
      bridgeProps: {
        deep: true,
        handler(props) {
          this.renderReact(props);
        },
      },
    },

    methods: {
      renderReact(props) {
        this.root.render(React.createElement(ReactComponent, props));
      },
    },

    mounted() {
      this.root = createRoot(this.$refs.mount);
      this.renderReact(this.bridgeProps);
    },

    beforeDestroy() {
      if (this.root) {
        this.root.unmount();
        this.root = null;
      }
    },
  };
}
